"use client";

import { ArrowRight, Sparkles, Target, Lightbulb, Rocket, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Groeiformule() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: stepsRef,
    isVisible: stepsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const steps = [{
    number: "01",
    title: "KENNISMAKING",
    description: "We leren jouw bedrijf, doelgroep en doelen kennen. Zo leggen we de basis voor een strategie die bij jouw merk past.",
    timeline: "Fase 1"
  }, {
    number: "02",
    title: "ANALYSE",
    description: "We analyseren jouw huidige online aanwezigheid, doelgroep en concurrentie. Deze inzichten vormen de basis voor een doordacht contentplan.",
    timeline: "Fase 2"
  }, {
    number: "03",
    title: "PRODUCTIE",
    description: "We produceren professionele foto's, video's en social content die perfect aansluiten bij jouw merk en doelgroep.",
    timeline: "Fase 3"
  }, {
    number: "04",
    title: "PUBLICATIE",
    description: "We plannen en publiceren de content op de juiste kanalen, zodat jouw merk consistent zichtbaar blijft.\n\n",
    timeline: "Fase 4"
  }, {
    number: "05",
    title: "OPTIMALISATIE",
    description: "We analyseren de resultaten, sturen de strategie waar nodig bij en blijven werken aan duurzame online groei.",
    timeline: "Fase 5"
  }];
  const stepIcons = [Sparkles, Target, Lightbulb, Rocket, TrendingUp];
  return <section data-section-id="3560" id="de-groeiformule" className="bg-[hsl(0,0%,13%)] py-20 md:py-28 lg:py-32">
      <div className="container mx-auto px-6 md:px-10 lg:px-16 max-w-7xl">
        {}
        <div ref={headerRef} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] text-white tracking-tighter uppercase">HOE MAKEN WIJ&nbsp;<br /><span className="text-[hsl(30,100%,50%)]" data-ast-id="f:/src/pages/Home/sections/Groeiformule.tsx|sig:m1dndu" data-ast-start="2206" data-ast-end="2427" contenteditable="false" style={{}}>JOUW MERK ZICHTBAAR?<br /></span></h2>
        </div>

        {}
        <div ref={stepsRef} className="relative">
          {}
          <div className="hidden md:block absolute -top-8 left-0 right-0 pointer-events-none">
            <div className="grid grid-cols-5 px-3">
              {stepIcons.map((IconComponent, i) => <div key={i} className="flex justify-start">
                  <div className={`transition-all duration-700 ease-out ${stepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`} style={{
                transitionDelay: stepsVisible ? `${i * 150}ms` : "0ms"
              }}>
                    <IconComponent className="size-5 text-[hsl(30,100%,50%)]/80" />
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className="hidden md:block absolute top-2 left-0 right-0 h-px pointer-events-none">
            <div className="relative w-full h-px bg-[hsl(0,0%,20%)]">
              <div className={`absolute inset-y-0 left-0 bg-[hsl(30,100%,50%)] transition-all duration-[2000ms] ease-out ${stepsVisible ? "w-full" : "w-0"}`} />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-12 md:gap-6 lg:gap-8">
            {steps.map((step, i) => <div key={i} data-index={i} className={`relative flex flex-col transition-all duration-700 ease-out ${stepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: stepsVisible ? `${i * 150}ms` : "0ms"
          }}>
                {}
                <div className="hidden md:flex items-center justify-start mb-8">
                  <div className="w-2.5 h-2.5 rounded-lg bg-[hsl(30,100%,50%)] -mt-[5px]" />
                </div>

                {}
                <div className="md:hidden h-px bg-[hsl(0,0%,20%)] w-12 mb-6">
                  <div className="w-2 h-2 rounded-lg bg-[hsl(30,100%,50%)] -mt-[3.5px]" />
                </div>

                {}
                <div className="font-default text-5xl md:text-6xl lg:text-[64px] leading-none text-white mb-6 md:mb-8 font-bold">
                  {step.number}
                </div>

                {}
                <h3 className="font-default text-[22px] md:text-[22px] leading-tight text-white mb-4 font-bold uppercase">
                  {step.title}
                </h3>

                {}
                <p className="font-default text-sm md:text-[15px] leading-relaxed text-white/70 mb-6 md:mb-8 flex-grow">
                  {step.description}
                </p>

                {}
                
              </div>)}
          </div>
        </div>

        {}
        <div ref={ctaRef} className={`mt-20 md:mt-28 flex flex-col items-center text-center gap-5 transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Link className="bg-[hsl(30,100%,50%)] text-[hsl(0,0%,10%)] hover:bg-[hsl(30,100%,45%)] font-bold px-7 py-6 rounded-md uppercase tracking-wider text-sm transition-all duration-300 underline cursor-pointer" href="#contact"><Button className="bg-[hsl(30,100%,50%)] text-[hsl(0,0%,10%)] hover:bg-[hsl(30,100%,45%)] font-bold px-7 py-6 rounded-md uppercase tracking-wider text-sm transition-all duration-300">
            Gratis Socials Scan
            <ArrowRight className="size-4 ml-1" />
          </Button></Link>
        </div>
      </div>
    </section>;
}